export const OAUTH_CLIENT_ID = '619763738231-dhgihmui6kif60sbeqojlku1hdd3oml9.apps.googleusercontent.com'
export const BACKEND_URI= 'https://api.crawler.thinkand.dev'
export const PUBLIC_URL = 'https://app.crawler.thinkand.dev'